// IMPORTANT: THIS FILE IS AUTO GENERATED! DO NOT MANUALLY EDIT OR CHECKIN!
/* tslint:disable */
/* eslint-disable */
export const VERSION = {
    "dirty": true,
    "raw": "v0.0.5-230-g0172044-dirty",
    "hash": "g0172044",
    "distance": 230,
    "tag": "v0.0.5",
    "semver": {
        "options": {
            "loose": false,
            "includePrerelease": false
        },
        "loose": false,
        "raw": "v0.0.5",
        "major": 0,
        "minor": 0,
        "patch": 5,
        "prerelease": [],
        "build": [],
        "version": "0.0.5"
    },
    "suffix": "230-g0172044-dirty",
    "semverString": "0.0.5+230.g0172044",
    "version": "1.0.0"
};
/* tslint:enable */
